exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg{background-color:#d3d3d3}.cell-padding tr td,th{padding:2px}#img{padding:1px;border:1px solid #021a40}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-540f8750","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/exam/ExamAdmitCardPrint.vue
// module id = 681
// module chunks = 0